var ProductReviews, base, base1,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

ProductReviews.PastPurchases = (base = window.ProductReviews).PastPurchases != null ? base.PastPurchases : base.PastPurchases = {};

ProductReviews.PastPurchases.Views = (base1 = window.ProductReviews.PastPurchases).Views != null ? base1.Views : base1.Views = {};

ProductReviews.PastPurchases.Collection = require('../collections/past_purchases');

ProductReviews.PastPurchases.Views.PastPurchaseList = require('./past_purchase_list');

ProductReviews.Views.ProductReview = require('./product_review');

ProductReviews.Views.Main = (function(superClass) {
  extend(Main, superClass);

  function Main() {
    return Main.__super__.constructor.apply(this, arguments);
  }

  Main.prototype.el = '#product-reviews';

  Main.prototype.userReviewEl = '#user-review';

  Main.prototype.events = {
    'mouseover #user-review .allow-submission .review-star': 'hoverStar',
    'click #user-review .allow-submission .review-star': 'clickStar',
    'mouseout #user-review .user-rating': 'clearHoverStar',
    'keyup #user-review .product-reviews-form-extension textarea': 'updateLengthNotification',
    'click #user-review .product-reviews-form-extension button': 'submitReview',
    'click #user-review .product-reviews-form-extension a': 'cancelReview',
    'click .allow-submission.vote-up': 'voteReviewUp',
    'click .allow-submission.vote-down': 'voteReviewDown',
    'click .vote-undo-link': 'voteUndo',
    'click .allow-submission.review-delete': 'deleteReview',
    'click .review-share': 'showShareTooltip',
    'click #product-reviews-pagination-button': 'showMoreReviews',
    'change #product-reviews-sort-select': 'resortReviews',
    'click #preview-page-all-reviews-button': 'showReviewsPage',
    'click .product-reviews-back-to-deal': 'backToDealPage',
    'click #product-reviews-pagination-footer li': 'renderPage'
  };

  Main.prototype.initialize = function() {
    if (this.$el == null) {
      this.$el = $(this.el);
    }
    this.$userReview = $(this.userReviewEl);
    _.extend(this, this.options);
    this.listenTo(this.model, 'change:rating', this.updateStars);
    this.initializeTooltips();
    this.initializeAnchors();
    this.initializeMessages();
    this.$body = $('body');
    this.$htmlBody = $('html, body');
    this.$header = $('header');
    this.$productReviews = $('#product-reviews');
    this.$preview = $('#product-reviews-preview');
    this.$userRating = this.$userReview.find('.user-rating');
    this.$ratingDescription = this.$userReview.find('.rating-description');
    this.$userReviewNotification = this.$userReview.find('.user-review-notification');
    this.$reviewFormExtension = this.$userReview.find('.product-reviews-form-extension');
    this.$reviewText = this.$userReview.find('.product-reviews-form-extension textarea');
    this.$reviewTextCount = this.$userReview.find('.product-reviews-form-extension .text-count');
    this.$reviewSubmit = this.$userReview.find('.product-reviews-form-extension button');
    this.$reviewCancel = this.$userReview.find('.product-reviews-form-extension a');
    this.$sortNotification = this.$el.find('#product-reviews-sort-notification');
    this.$paginationNotification = this.$el.find('#product-reviews-pagination-notification');
    this.$paginationLoader = this.$el.find('#product-reviews-pagination-loader');
    this.$paginationButton = this.$el.find('#product-reviews-pagination');
    this.$reviewFilter = this.$el.find('#product-reviews-sort-select');
    this.$reviewList = this.$el.find('#product-reviews-list');
    this.$reviewsPageHeader = this.$el.find('#product-reviews-page-header');
    this.$reviewsHeader = this.$el.find('#product-reviews-header');
    return this.$reviewsQuickView = $('#product-reviews-quick-view');
  };

  Main.prototype.initializeTooltips = function() {
    this.$quickViewTooltipTrigger = $('#product-reviews-quick-view.tooltip-trigger');
    this.$formRatingTooltipTrigger = $('#product-reviews-form-rating.tooltip-trigger');
    this.$quickViewTooltip = $('#product-reviews-quick-view-tooltip');
    this.$loginRequiredTooltip = $('#product-reviews-login-required-tooltip');
    this.$shareTooltip = $('#product-reviews-share-tooltip');
    this.$tooltips = $('.tooltip');
    this.$quickViewTooltipTrigger.mouseover((function(_this) {
      return function(e) {
        return _this.$quickViewTooltip.attr('data-trigger', 'product-reviews-quick-view');
      };
    })(this));
    return this.$formRatingTooltipTrigger.mouseover((function(_this) {
      return function(e) {
        return _this.$quickViewTooltip.attr('data-trigger', 'product-reviews-form-rating');
      };
    })(this));
  };

  Main.prototype.initializeAnchors = function() {
    this.$anchors = $('#product-ratings, .product-reviews-anchor');
    this.$stickyHeader = $('#sticky-head');
    return this.$anchors.click((function(_this) {
      return function(e) {
        e.preventDefault();
        return _this.scrollToProductReviews();
      };
    })(this));
  };

  Main.prototype.scrollToProductReviews = function() {
    var $productReviewsEl;
    if (this.$body.hasClass('show-pr-submission' || this.$body.hasClass('product-reviews-page-active'))) {
      return;
    }
    $productReviewsEl = this.displayOptions.showReviewsPage && !this.$body.hasClass('product-reviews-page-active') ? this.$preview : this.$productReviews;
    return this.$htmlBody.animate({
      scrollTop: $productReviewsEl.offset().top - this.$stickyHeader.outerHeight()
    }, 'slow');
  };

  Main.prototype.scrollToTop = function() {
    return this.$htmlBody.animate({
      scrollTop: this.$header.outerHeight()
    }, 'slow');
  };

  Main.prototype.render = function(reviewList) {
    this.resetNotifications();
    reviewList.render();
    this.reloadBindings();
    this.updatePagination();
    this.$paginationLoader.hide();
    return this.$reviewList.show();
  };

  Main.prototype.hideMessages = function() {
    this.hideTooltips();
    return this.resetNotifications();
  };

  Main.prototype.httpsRedirect = function(element) {
    return window.location.assign("" + this.dealUrl + element);
  };

  Main.prototype.showShareTooltip = function(e) {
    var $reviewCard, emailBody, emailSubject, hrefText, text, username;
    $reviewCard = $(e.currentTarget).closest(".review-card");
    if ($reviewCard.length) {
      username = $reviewCard.find('.review-display-name').data('display-name');
      text = $reviewCard.find('.review-text').text();
      emailSubject = encodeURIComponent(I18n.t('js.modules.product_reviews.share_review.email_subject', {
        dealTitle: this.dealTitle,
        username: username
      }));
      emailBody = encodeURIComponent(this.dealTitle + "\n" + this.dealUrl + "\n\n\"" + text + "\"\n- " + username);
      hrefText = "mailto:?subject=" + emailSubject + "&body=" + emailBody + "&utm_campaign=UserReferral&utm_medium=email&utm_source=uu";
      return this.$shareTooltip.find('.icon-email').attr('href', hrefText);
    }
  };

  Main.prototype.showMoreReviews = function() {
    this.hideMessages();
    this.$paginationLoader.show();
    return this.collection.nextPage(this.$reviewFilter.val());
  };

  Main.prototype.renderPage = function(e) {
    var page;
    if ($(e.currentTarget).hasClass('disabled')) {
      return;
    }
    page = $(e.currentTarget).find('.page-number').data('page-number');
    this.$htmlBody.animate({
      scrollTop: this.$reviewsPageHeader.offset().top - this.$stickyHeader.outerHeight()
    }, 'slow');
    this.$paginationLoader.show();
    this.collection.getPage(parseInt(page));
    return this.hideMessages();
  };

  Main.prototype.showReviewsPage = function() {
    this.$body.addClass('product-reviews-page-active');
    this.$reviewsQuickView.removeAttr('data-tooltip-id');
    this.scrollToTop();
    return this.hideMessages();
  };

  Main.prototype.backToDealPage = function() {
    this.$body.removeClass('product-reviews-page-active show-pr-submission');
    this.$reviewsQuickView.attr('data-tooltip-id', 'product-reviews-quick-view-tooltip');
    return this.cancelReview();
  };

  Main.prototype.sendDropdownTrackingEvent = function() {
    return OptimizeSuite.TrackingHub.add('product-reviews-sort', {
      data: this.$reviewFilter.val()
    });
  };

  Main.prototype.resortReviews = function() {
    this.hideMessages();
    if (!this.displayOptions.showReviewsPage) {
      this.$reviewList.hide();
    }
    this.$paginationLoader.show();
    this.collection.resortReviews(this.$reviewFilter.val());
    return this.sendDropdownTrackingEvent();
  };

  Main.prototype.updatePagination = function() {
    var displayedReviewCount, reviewsLength;
    reviewsLength = this.collection.length;
    displayedReviewCount = {
      formatted: I18n.toNumber(reviewsLength),
      value: reviewsLength
    };
    this.$el.find('#product-reviews-display-count span').text(I18n.t('js.modules.product_reviews.pagination.showing_count', {
      formattedDisplayedReviewCount: displayedReviewCount.formatted,
      formattedReviewCount: this.reviewCount.formatted
    }));
    if (displayedReviewCount.value < this.reviewCount.value) {
      return this.$paginationButton.show();
    } else {
      return this.$paginationButton.hide();
    }
  };

  Main.prototype.findReview = function(placement, id) {
    switch (placement) {
      case 'helpful':
        return this.helpfulCollection.get(id);
      case 'preview':
        return this.previewCollection.get(id);
      default:
        return this.collection.get(id);
    }
  };

  Main.prototype.showPaginationError = function(action) {
    this.$paginationLoader.hide();
    this.$reviewList.show();
    this.$reviewFilter.val(this.collection.sortBy);
    switch (action) {
      case 'nextPage':
      case 'getPage':
        return this.$paginationNotification.show();
      case 'resortReviews':
        return this.$sortNotification.show();
    }
  };

  Main.prototype.clickStar = function(e) {
    if (!this.reviewable) {
      return this.httpsRedirect('#product-reviews');
    }
    this.hideTooltips();
    if (this.displayOptions.showReviewSubmissionPage && !this.$body.hasClass('show-pr-submission')) {
      this.showSubmissionPage();
    }
    this.model.set('rating', $(e.currentTarget).data('star-rating'));
    return this.$reviewFormExtension.slideDown('slow');
  };

  Main.prototype.cancelReview = function() {
    this.resetForm();
    if (!this.$body.hasClass('show-pr-submission')) {
      return;
    }
    this.$body.removeClass('show-pr-submission');
    return this.scrollToTop();
  };

  Main.prototype.deleteReview = function(e) {
    if (!this.reviewable) {
      return this.httpsRedirect(this.el);
    }
    this.resetNotifications();
    return this.model["delete"]();
  };

  Main.prototype.voteReview = function(e, fnName) {
    var $target, anchor, review;
    $target = $(e.currentTarget);
    if (!this.reviewable) {
      anchor = (function() {
        switch ($target.data('review-placement')) {
          case 'helpful':
            return '#product-reviews-helpful-reviews';
          case 'preview':
            return '#product-reviews-preview-list';
          default:
            return '#product-reviews-list';
        }
      })();
      return this.httpsRedirect(anchor);
    }
    review = this.findReview($target.data('review-placement'), $target.data('review-id'));
    $target.parent().children('button').attr('disabled', 'disabled');
    this.resetNotifications();
    review.view = this;
    return typeof review[fnName] === "function" ? review[fnName]() : void 0;
  };

  Main.prototype.voteReviewUp = function(e) {
    return this.voteReview(e, 'upvote');
  };

  Main.prototype.voteUndo = function(e) {
    return this.voteReview(e, 'unvote');
  };

  Main.prototype.voteReviewDown = function(e) {
    return this.voteReview(e, 'downvote');
  };

  Main.prototype.showVoteSuccess = function(model) {
    var button, helpfulUpvote, i, len, noButton, ref, results, reviewIds;
    reviewIds = model.get('reviewIds');
    helpfulUpvote = model.get('helpfulUpvote');
    noButton = $("#" + reviewIds.voteDown);
    if (noButton.length) {
      noButton.parent().hide();
    }
    this.$el.find("#" + reviewIds.voteText).text(helpfulUpvote.text);
    $("#" + reviewIds.voteUndo).show();
    if (this.displayOptions.showReviewsPage) {
      ref = $("button[data-review-id=" + model.id + "]");
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        button = ref[i];
        $(button).prop('disabled', true);
        results.push($(button).parent().hide());
      }
      return results;
    }
  };

  Main.prototype.showVoteError = function(model) {
    var helpfulUpvote, noButton, reviewIds, yesButton;
    reviewIds = model.get('reviewIds');
    helpfulUpvote = model.get('helpfulUpvote');
    yesButton = $("#" + reviewIds.voteUp).removeAttr('disabled');
    noButton = $("#" + reviewIds.voteDown).removeAttr('disabled');
    return this.$el.find("#" + reviewIds.notification).removeClass('success').addClass('error').text(this.reviewVoteErrorMessage).show();
  };

  Main.prototype.showUnvoteSuccess = function(model) {
    var button, helpfulUpvote, i, len, ref, results, reviewIds;
    reviewIds = model.get('reviewIds');
    helpfulUpvote = model.get('helpfulUpvote');
    $("#" + reviewIds.voteUp).removeAttr('disabled');
    $("#" + reviewIds.voteDown).removeAttr('disabled');
    $("#" + reviewIds.card + " .review-vote").show();
    this.$el.find("#" + reviewIds.voteText).text(helpfulUpvote.text);
    this.$el.find("#" + reviewIds.notification).removeClass('error').addClass('success').text(this.reviewUnvoteSuccessMessage).show();
    if (this.displayOptions.showReviewsPage) {
      ref = $("button[data-review-id=" + model.id + "]");
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        button = ref[i];
        $(button).removeProp('disabled');
        results.push($(button).parent().show());
      }
      return results;
    }
  };

  Main.prototype.showUnvoteError = function(model) {
    var reviewIds;
    reviewIds = model.get('reviewIds');
    return this.$el.find("#" + reviewIds.notification).removeClass('success').addClass('error').text(this.reviewUnvoteErrorMessage).show();
  };

  Main.prototype.showSubmissionPage = function() {
    this.$body.addClass('show-pr-submission');
    this.scrollToTop();
    return this.pastPurchases != null ? this.pastPurchases : this.pastPurchases = new ProductReviews.PastPurchases.Collection([], {
      rootUrl: this.rootUrl,
      csrf: this.csrf,
      dealUuid: this.dealUuid,
      source: this.source,
      view: this
    });
  };

  Main.prototype.showPastPurchases = function() {
    (new ProductReviews.PastPurchases.Views.PastPurchaseList({
      collection: this.pastPurchases
    })).render();
    return this.hidePastPurchasesLoader();
  };

  Main.prototype.hidePastPurchasesLoader = function() {
    return $('#product-reviews-past-purchases .loader').hide();
  };

  return Main;

})(ProductReviews.Views.ProductReview);

module.exports = ProductReviews.Views.Main;

//# sourceMappingURL=data:application/json;base64,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
